/* Piventra clone – interactions */

// ── Product gallery ──────────────────────────────────────────
(function () {
  const main = document.getElementById('mainMedia');
  const thumbs = document.getElementById('thumbs');
  if (!main || !thumbs) return;

  thumbs.addEventListener('click', function (e) {
    const btn = e.target.closest('.thumb');
    if (!btn) return;
    main.src = btn.dataset.src;
    thumbs.querySelectorAll('.thumb').forEach(t => t.classList.remove('is-active'));
    btn.classList.add('is-active');
  });
})();

// ── FAQ accordion – only one open at a time ──────────────────
(function () {
  const items = document.querySelectorAll('.faq__item');
  items.forEach(item => {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      items.forEach(other => { if (other !== item) other.open = false; });
    });
  });
})();

// ── Scroll to top ────────────────────────────────────────────
(function () {
  const btn = document.getElementById('scrollTop');
  if (!btn) return;

  const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 600);
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
})();

// ── Add to cart ──────────────────────────────────────────────
// The bundle radios carry the real Shopify variant IDs (name="id"),
// so the form posts straight to /cart/add. This only guards against
// submitting with nothing selected.
(function () {
  const form = document.getElementById('grippo-cart-form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    if (!form.querySelector('input[name="id"]:checked')) {
      e.preventDefault();
      const first = form.querySelector('input[name="id"]');
      if (first) first.checked = true;
      form.submit();
    }
  });
})();
